import { useState, useEffect, useCallback, Suspense } from "react";
import { ThemeFormSubHeader } from "../../../../../shared/themeFormSubHeader";
import DependentClaimsGrid from "./dependentClaimsGrid/DependentClaimsGrid";

const DependentClaims = () => {
	const [dependentClaims, setDependentClaims] = useState([]);

	const getDependentClaims = useCallback(() => {
		const _dependentClaims = [
			{
				claim_number: "2022-150-000026-000",
				paitent_name: "",
				date_of_service: "03-10-22",
				type: "Dental/Professional/Institution",
				provider_name: "North Houston Family Medicine",
				status: "Paid",
				paid_date: "04-10-22",
				charges: "$418.00",
				paid_by_plan: "$315.71"
			},
			{
				claim_number: "2022-150-000026-000",
				paitent_name: "",
				date_of_service: "03-10-22",
				type: "Dental/Professional/Institution",
				provider_name: "North Houston Family Medicine",
				status: "Paid",
				paid_date: "04-10-22",
				charges: "$418.00",
				paid_by_plan: "$315.71"
			},
			{
				claim_number: "2022-150-000026-000",
				paitent_name: "",
				date_of_service: "03-10-22",
				type: "Dental/Professional/Institution",
				provider_name: "North Houston Family Medicine",
				status: "Paid",
				paid_date: "04-10-22",
				charges: "$418.00",
				paid_by_plan: "$315.71"
			}
		];
		setDependentClaims(Object.assign([], _dependentClaims));
	}, []);

	useEffect(() => {
		getDependentClaims();
	}, [getDependentClaims]);
	return (
		<>
			<Suspense fallback={<div />}>
				<ThemeFormSubHeader title={"Claim Information"} actionButtons={[]} style={{ marginBottom: "1rem" }} />
			</Suspense>
			<DependentClaimsGrid dependentClaims={dependentClaims} />
		</>
	);
};

export default DependentClaims;
